import type { MaybeN } from "@agrigate/ts-utils/lib/types";
import { Button } from "@chakra-ui/react";

export default function ContentEditorLink(p: {
    contentMgmtUrl?: MaybeN<string>;
    label?: MaybeN<string>;
}) {
    if (!p.contentMgmtUrl) return null;
    return (
        <Button
            alignSelf="right"
            onClick={() => {
                if (!p.contentMgmtUrl) {
                    window.open(`${p.contentMgmtUrl}${location.hash}`);
                }
            }}
            size="xs"
            variant={"subtle"}
        >
            {p.label ?? "Open Editor"}
        </Button>
    );
}
